import reducer from "./ThemeReducer";
import { combineReducers } from "redux";

const rootReducer = combineReducers({ reducer });

export default rootReducer;
